import React from 'react';
import { Card } from '../ui/card';
import { Button } from '../ui/button';
import { Microscope, ExternalLink, Sparkles } from 'lucide-react';
import { CommentAnalysis } from './CommentAnalysis';
import { useNavigate } from 'react-router-dom';
interface ResearchToolsProps {
  taskId: string;
  videoId?: string;
}
export function ResearchTools({
  taskId,
  videoId
}: ResearchToolsProps) {
  const navigate = useNavigate();
  return <Card data-id="element-1330">
      <div className="flex items-center justify-between p-4 md:p-5 border-b border-border/40" data-id="element-1331">
        <h2 className="font-semibold text-base md:text-lg flex items-center gap-2" data-id="element-1332">
          <Microscope size={20} className="text-primary" data-id="element-1333" />
          Comment Research
          <span className="text-xs bg-primary/10 text-primary px-2 py-0.5 rounded-full font-medium" data-id="element-1334">
            Advanced
          </span>
        </h2>
        <Button variant="outline" size="sm" className="h-8 text-xs" onClick={() => navigate(`/app/research/${taskId}`)} data-id="element-1335">
          Full Workbench
          <ExternalLink size={12} className="ml-2" data-id="element-1336" />
        </Button>
      </div>

      <div className="p-4 md:p-5 space-y-3" data-id="element-1337">
        <CommentAnalysis taskId={taskId} videoId={videoId} data-id="element-1338" />

        <div className="pt-2 border-t border-border/20" data-id="element-1339">
          <p className="text-xs text-muted-foreground flex items-center gap-1" data-id="element-1340">
            <Sparkles size={12} data-id="element-1341" />
            More research tools coming soon
          </p>
        </div>
      </div>
    </Card>;
}